import React, {useState, useRef} from 'react';
import {ArrowLeft, X} from "react-feather";
import {deleteConversationFile, getVendorAccounts, postBrokerConversationStart} from "../../services/api/messaging";
import {MESSAGE_MAX, MESSAGE_TOPIC_MAX} from "../../services/constants/MaxLenght";
import VendorSearch from "../Input/VendorSearch";
import AccountFilter from "../Input/AccountFilter";
import FileUpload from "../Input/FileUpload";
import FileList from "../Input/FileList";
import LinkFormatterInput from "../Common/LinkFormatterInput";
import {formatLinksInText} from "../../services/helpers";

const ModalStartConversation = ({onHandleToggle, onMessageSent}) => {
    const topicRef = useRef(null);
    const messageRef = useRef(null);
    const [messageContent, setMessageContent] = useState('');
    const [topicContent, setTopicContent] = useState('');
    const [isUploading, setIsUploading] = useState(false);

    const [sendingMessage, setSendingMessage] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState();
    const [vendorAccounts, setVendorAccounts] = useState([]);
    const [selectedAccountIds, setSelectedAccountIds] = useState([]);

    const handleSelectedAccountIdsChange = (ids) => {
        setSelectedAccountIds(ids);
    };
    const handleVendorSelect = (vendor) => {
        setSelectedVendor(vendor);
        setVendorAccounts([]);
        const fetchVendorAccounts = async () => {
            try {
                const result = await getVendorAccounts(vendor.id);
                setVendorAccounts(result);

                const primaryAccount = result.find(account => account.is_primary);
                setSelectedAccountIds(primaryAccount ? [primaryAccount.id] : []);

            } catch (error) {
                console.error('Error fetching messages:', error);
            }
        };

        fetchVendorAccounts().then(result => result);
    };
    const onBack = () => {
        setSelectedAccountIds([]);
        setSelectedVendor(null);
        setTopicContent('');
        setMessageContent('');
        setFiles([]);
    };

    function handleTopicChange() {
        const topic = topicRef.current.value;
        setTopicContent(topic);

        if (topic.length > MESSAGE_TOPIC_MAX) {
            topicRef.current.classList.add('sl-input-destructive');
        } else {
            topicRef.current.classList.remove('sl-input-destructive');
        }
    }

    function handleContentChange(value) {
        setMessageContent(value)

        if (value.length > MESSAGE_MAX) {
            messageRef.current.classList.add('sl-input-destructive');
        } else {
            messageRef.current.classList.remove('sl-input-destructive');
        }
    }

    const handleSendMessage = async (event) => {
        event.preventDefault();
        setSendingMessage(true);

        const topic = topicRef.current.value;


        if ((topic.trim()).length > MESSAGE_TOPIC_MAX) {
            topicRef.current.classList.add('sl-input-destructive');
        }

        if ((messageContent.trim()).length > MESSAGE_MAX) {
            messageRef.current.classList.add('sl-input-destructive');
        }

        if (selectedAccountIds.length === 0) {
            return false;
        }

        const payload = {
            'vendor_id': selectedVendor.id,
            'account_ids': selectedAccountIds,
            'topic': topic,
            'content': formatLinksInText(messageContent, true),
        };

        if ((topic.trim()).length > MESSAGE_TOPIC_MAX) {
            setSendingMessage(false);
            return;
        }

        if ((messageContent.trim()).length > MESSAGE_MAX) {
            setSendingMessage(false);
            return;
        }

        if (files) {
            payload['uploads'] = files;
        }
        await postBrokerConversationStart(payload).then(response => {
            onMessageSent(response);
        });
        onHandleToggle();
        setSendingMessage(false);
    };

    const [files, setFiles] = useState([]);
    const handleFileUploading = (file) => {
        setIsUploading(true);
        setFiles((prevFiles) => {
            const existingFile = prevFiles.find((prevFile) => prevFile.name === file.name);

            if (existingFile) {
                return prevFiles.map((prevFile) =>
                    prevFile.name === file.name ? {...prevFile, ...file} : prevFile
                );
            } else {
                return [...prevFiles, file];
            }
        });
    };

    const handleFileUploaded = () => {
        setIsUploading(false);
    };

    const handleFileRemove = (fileToRemove) => {
        setFiles((prevFiles) => prevFiles.filter((prevFile) => prevFile.location !== fileToRemove.location));
        deleteConversationFile(fileToRemove.location).then(r => r);
    };

    return (
        <div className="sl-modal-body">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Send a Message
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>
            <div className="sl-modal-body">
                {!selectedVendor && <div
                    className="sl-modal-body sl-max-h-112 sl-h-auto sl-px-6 sl-pb-0 sl-pt-24 sl-customized-scrollbar">
                    <div className="sl-flex sl-flex-col sl-gap-6">
                        <div className="sl-text-md sl-font-normal sl-text-gray-900">
                            Select the vendor you'd like to send a message to.
                        </div>

                        <VendorSearch onVendorSelect={handleVendorSelect}/>
                    </div>
                </div>}


                {selectedVendor &&
                    <div className="sl-modal-body">
                        <div
                            className="sl-flex sl-px-6 sl-pb-0 sl-pt-24 sl-border-bottom sl-flex-col sl-gap-6 sl-max-h-75 sl-min-h-58 sl-h-auto sl-overflow-y-scroll sl-customized-scrollbar">
                            <div className="sl-text-md sl-font-normal sl-text-gray-900">
                                Select the message recipients from {selectedVendor.name}.
                            </div>
                            <AccountFilter accounts={vendorAccounts} selectedIds={selectedAccountIds}
                                           onSelectedIdsChange={handleSelectedAccountIdsChange}/>
                        </div>
                        <div className="sl-px-6 sl-pb-0 sl-pt-24">
                            <div
                                className="sl-mt-6 sl-flex sl-flex-col sl-justify-start sl-w-fill-available sl-gap-1-point-5 sl-mt-0i">
                                <input ref={topicRef}
                                       value={topicContent}
                                       onChange={handleTopicChange}
                                       className="sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-font-normal sl-text-md sl-text-gray-base sl-px-14 sl-py-10"
                                       type="text" placeholder="Subject Line"/>
                            </div>

                            <div className="sl-mt-6">
                                <div className="sl-pb-3">
                                    <FileList fileList={files} onRemoveFile={handleFileRemove}/>
                                </div>
                                <div
                                    className="sl-flex sl-flex-col sl-justify-start sl-w-fill-available sl-gap-1-point-5">
                                    <LinkFormatterInput
                                        placeholder="Send a Message"
                                        inputRef={messageRef}
                                        value={messageContent}
                                        onChange={handleContentChange}/>
                                </div>


                            </div>

                            <div className="sl-mr-auto sl-mt-3">
                                <FileUpload onUploading={handleFileUploading}
                                            onUploaded={handleFileUploaded}/>
                            </div>

                        </div>
                    </div>}
            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32">
                {selectedVendor &&
                    <button disabled={sendingMessage}
                            className="sl-cursor-pointer sl-flex sl-align-center sl-justify-self-start sl-gap-2 sl-mr-auto sl-btn-link-gray"
                            onClick={onBack}>
                        <ArrowLeft/>
                        Back
                    </button>}
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle} disabled={sendingMessage}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg">
                        Cancel
                    </button>
                    <button onClick={handleSendMessage} disabled={sendingMessage || isUploading
                        || (topicContent.trim()).length > MESSAGE_TOPIC_MAX
                        || (messageContent.trim()).length > MESSAGE_MAX
                        || (messageContent.trim() === '' && files.length === 0)}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalStartConversation;
